import useSWR, { type SWRConfiguration } from 'swr';
import denApi from '@/lib/api/denApi';
import type { PendingGroupProposalWithSignatures } from '@/types/group-proposal';
import { useMyOrganization } from '@/hooks/organization/use-my-organization';
import { SIGNABLE_POLL_INTERVAL_MS } from '@/components/execution/execution-polling';

const fetcher = async (url: string) =>
  await denApi.get<PendingGroupProposalWithSignatures[], void>(url);

export function usePendingGroupProposals(
  swrOptions?: SWRConfiguration<PendingGroupProposalWithSignatures[]>
) {
  const { organization } = useMyOrganization();
  const isAdmin = Boolean(organization?.isAdmin);
  // Org context comes from x-current-org-id cookie (not URL params)
  const url = isAdmin ? `admin/group/group-proposals/pending` : null;
  const { data, error, isLoading, mutate } = useSWR<
    PendingGroupProposalWithSignatures[]
  >(url, fetcher, {
    revalidateOnFocus: false,
    refreshInterval: SIGNABLE_POLL_INTERVAL_MS,
    ...(swrOptions ?? {}),
  });

  return {
    proposals: data ?? [],
    error,
    isLoading,
    refresh: mutate,
  };
}
